import axios from "axios";

const put = ({ id, status }) => {
  const body = {
    status: status
  };

  return new Promise((resolve, reject) => {
    axios
      .put(`/campaign/api/admin/instant-lucky-draw/prizes/${id}/status`, body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const prizeStatus = {
  put
};

export default prizeStatus;
